export default __webpack_public_path__ + "static/media/network-error.22f0e6d1.svg";